const runProgressStep = ({
  setRunning,
  setProgress,
  fallbackDurationMs,
  estimatedDurationSeconds,
  onComplete,
  scale,
}) => {
  setRunning(true);
  setProgress(0);

  const duration =
    estimatedDurationSeconds != null
      ? estimatedDurationSeconds * 1000 * (scale || 1)
      : fallbackDurationMs;

  const intervalDuration = 1000;
  const totalTicks = duration / intervalDuration;
  let ticks = 0;

  const interval = setInterval(() => {
    ticks++;
    setProgress((ticks / totalTicks) * 100);

    if (ticks >= totalTicks) {
      clearInterval(interval);
      setProgress(100);
      onComplete();
    }
  }, intervalDuration);
};

export default runProgressStep;
